import { useState } from "react";
import { getAPIData } from "../Utils/commonApi";
import { useAuth } from "../Components/context/Auth";

const useGetSBSidebarNav = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const { authTokens } = useAuth();

  const getSidebarNav = () => {
    setIsLoading(true);
    getAPIData(`${0}`, authTokens)
      .then((response) => {
        setData(response?.MenuVisbility?.MenuItem_List?.sort((a, b) => a.SortOrder - b.SortOrder));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return {
    isLoading: isLoading && !data?.length,
    data,
    getSidebarNav
  }
}

export default useGetSBSidebarNav;
